import React from 'react'

import getDisplayName from '../getDisplayName'

import { connect } from '../../_redux'
import { IUserState } from '../../_redux/user/reducers'

interface IProps {
  user: IUserState
}

export interface WithRolesGuardProps {
  rolesGuard: {
    hasRoles: (roles: string[]) => boolean
    userLoading: () => boolean
  }
}

const withRolesGuard = () => (WrappedComponent: React.ComponentType<any>) => {
  const WithRolesGuard = (props: IProps) => {
    const {
      user: { data },
    } = props

    const hasRoles = (roles: string[]) => {
      if (data.roles) {
        const authorized = roles.reduce((acc, role) => {
          if (data.roles && data.roles.indexOf(role) !== -1) return true
          return acc
        }, false)
        return authorized
      }

      return false
    }

    const userLoading = () => {
      return true && props.user.loading
    }

    return (
      /**
       * What we do here:
       * - Use Route to get information about the original route
       * - Display original component if auth is correct, else redirect to login with original route sent as prop
       */
      <WrappedComponent rolesGuard={{ hasRoles, userLoading }} {...props} />
    )
  }

  WithRolesGuard.displayName = `WithRolesGuard(${getDisplayName(WrappedComponent)})`

  return connect(state => ({
    user: state.user,
  }))(WithRolesGuard)
}

export default withRolesGuard
